function parseNumber(str) {
  return parseFloat(str.replace(/[^\d.]/g, '')) || 0;
}

let lastFormattedPrice = '';

function updateTotal() {
  const propertySpans = document.querySelectorAll('.product-details__item--property span');
  if (!propertySpans.length) return;

  let additionalSum = 0;
  propertySpans.forEach(span => {
    additionalSum += parseNumber(span.textContent);
  });

  const totalPriceEl = document.querySelector('.t4s-cart__totalPrice');
  if (!totalPriceEl) return;

  const baseText = totalPriceEl.getAttribute('data-base-price') || totalPriceEl.textContent;
  const basePrice = parseNumber(baseText);
  const expectedTotal = basePrice + additionalSum;
  const expectedFormatted = `$${expectedTotal.toFixed(2)} USD`;
  
  // Check if current displayed total is wrong
  const currentTotal = parseNumber(totalPriceEl.textContent);
  
  // Only update if the displayed total doesn't match the expected total
  if (Math.abs(currentTotal - expectedTotal) > 0.01) { // Using small threshold for floating point comparison
    //totalPriceEl.textContent = expectedFormatted;
    totalPriceEl.setAttribute('data-base-price', basePrice);
    lastFormattedPrice = expectedFormatted;
  }
}

setInterval(updateTotal, 100);